export enum WidgetEventsEnum {
  WIDGET_CONFIG_READY = "widget:config:ready",
  WIDGET_READY = "widget:ready",
  WIDGET_POPUP_TOGGLED = "widget:popup-toggled"
}
